module.exports = __webpack_public_path__ + "img/popup_bg.e9152f8d.png";